var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"theme-class",rawName:"v-theme-class",value:(_vm.$root.color.redBtn),expression:"$root.color.redBtn"}],staticClass:"mdui-fab mdui-fab-fixed mdui-ripple scroll-to-top",class:{
    'mdui-fab-mini': _vm.$root.smallScreen,
    'mdui-fab-hide': !this.show,
    'need-offset': _vm.offset,
  },on:{"click":_vm.scrollTop}},[_c('i',{staticClass:"mdui-icon material-icons"},[_vm._v("vertical_align_top")])])
}
var staticRenderFns = []

export { render, staticRenderFns }